import React from 'react';
import Component from '@vfuk/core-list-item';
const ListItem = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ListItem;
